export default __webpack_public_path__ + "static/media/og.c5aafd6a.png";